module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "launch-screen"
  }, [_c('f7-block', [_c('div', {
    staticClass: "placeholder"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder__inner"
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder__text"
  })])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e741f88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e741f88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/launch-screen.page.vue
// module id = 848
// module chunks = 0